import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CreateParkingTariffDTO,
         ParkingTariffClient,
         ParkingTariffDTO,
         UpdateParkingTariffDTO} from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable()
export class TariffDetailsService {

  public loadedTariff: ParkingTariffDTO;
  public isBusy = false;

  constructor(private parkingTariffClient: ParkingTariffClient,
              private toastService: ToastService,
              private spinnerService: SpinnerService) {}

  public reset(): void {
    this.isBusy = false;
  }

  getTariff(tariffId: number): Observable<ParkingTariffDTO> {
    this.loadedTariff = null;
    this.spinnerService.show();
    this.isBusy = true;
    return this.parkingTariffClient.getParkingTariff(tariffId)
      .pipe(
        tap((tariff: ParkingTariffDTO) => {
          this.spinnerService.hide();
          this.isBusy = false;
          this.loadedTariff = tariff;
        }),
        catchError((error: any) => {
          this.spinnerService.hide();
          this.isBusy = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public createParkingTariff(createTariff: CreateParkingTariffDTO): Observable<ParkingTariffDTO> {
    this.spinnerService.show();
    this.isBusy = true;
    return this.parkingTariffClient.createParkingTariff(createTariff)
    .pipe(
      tap(() => {
        this.spinnerService.hide();
        this.isBusy = false;
        this.toastService.showSuccess(
          'i18n.domain.administration.tariff-details.messages.create-title',
          'i18n.domain.administration.tariff-details.messages.create-success-message'
        );
      }),
      catchError((error: any) => {
        this.spinnerService.hide();
        this.isBusy = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  public updateParkingTariff(updateParkingTariff: UpdateParkingTariffDTO): Observable<ParkingTariffDTO> {
    this.spinnerService.show();
    this.isBusy = true;
    return this.parkingTariffClient.updateParkingTariff(updateParkingTariff)
    .pipe(
      tap(() => {
        this.spinnerService.hide();
        this.isBusy = false;
        this.toastService.showSuccess(
          'i18n.domain.administration.tariff-details.messages.update-title',
          'i18n.domain.administration.tariff-details.messages.update-success-message'
        );
      }),
      catchError((error: any) => {
        this.spinnerService.hide();
        this.isBusy = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  public deleteParkingTariff(tariffId: number) {
    this.spinnerService.show();
    this.isBusy = true;
    return this.parkingTariffClient.deleteParkingTariff(tariffId)
    .pipe(
      tap(() => {
        this.spinnerService.hide();
        this.isBusy = false;
        this.toastService.showSuccess(
         'i18n.domain.administration.tariff-details.messages.delete-title',
         'i18n.domain.administration.tariff-details.messages.delete-success-message'
      );
    }),
    catchError((error: any) => {
      this.spinnerService.hide();
      this.isBusy = false;
      if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
        this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
      }
        return throwError(() => error);
      })
    );
  }
}

